// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Page, H, Link } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
import ClientSearch from "../../ClientSearch";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Search.m.scss";

@themr("front-page", styles)
export default class Search extends Component {
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      pageHeader: "Поиск клиента",
    };
  }

  setHeader = ({ pageHeader }) => {
    this.setState({ pageHeader });
  };

  render() {
    const { theme, basePath } = this.props;
    const { pageHeader } = this.state;
    return (
      <Page
        showHeader={false}
        breadcrumb={() => (
          <React.Fragment>
            <Link type="alt" to={`/`}>
              {"главная"}
            </Link>
            <div>{"->"}</div>
            <H
              t={"h4"}
              // theme={{
              //   wrapper: theme.header,
              // }}
            >
              {pageHeader}
            </H>
          </React.Fragment>
        )}
      >
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.content)}>
            <ClientSearch basePath={basePath} />
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Search/Search.js